import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	Image,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useOfertaCard } from '../../../context/ofertas-card-context';
import { OfertasContext } from '../../../context/ofertas-context';
import { CarlineWithOfertas, Oferta } from '../../../services/ofertas-service/models/ofertas';
import { RedirectCTAs } from '../../redirect-cta';
import { OpenLayerCTA } from '../oferta-cta';
import { OfertaPrice } from '../oferta-price';
import { OfertaCardTitleMobile } from './oferta-card-title-mobile';
import { CardControllers, OpenLayerCTAContainer, TwoColumnsDiv } from './ui/oferta-card-mobile-styles';

const OfertaCardImageContainer = styled.div`
	min-height: 180px;

	@media screen and (min-width: 560px) and (max-width: 979px) {
		min-height: 250px;
	}
`;

const OfertaCardImage = styled(Image as any)`
	@media screen and (max-width: 559px) {
		display: block;
		margin: 0 auto;
		width: 110%;
		height: auto;
		object-fit: cover;
		transform: translateX(-5%);
	}
`;

const OfertaInfoContainer = styled.div`
	/* flexbox interno para alinear el CTA al final */
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
`;

export const OfertaCardMobile = ({
	carline,
	currentOferta,
	className,
	visibleOfertaMobile,
}: {
	carline: CarlineWithOfertas;
	currentOferta: Oferta;
	className?: string;
	visibleOfertaMobile: Oferta;
}): React.ReactElement => {
	const { serviceConfigProvider } = React.useContext(OfertasContext);

	const { selectedOferta, isCallMeNowOpen } = useOfertaCard();
	const mediaAssets = currentOferta.configuracion.mediaAssets;
	let img34 = mediaAssets?.D6Turntable1 || mediaAssets?.Front_Left || mediaAssets?.D6Explore1Alpha;

	if (!img34 && mediaAssets) img34 = Object.values(mediaAssets).find(Boolean); // Mostramos alguna imagen

	return (
		<OfertaInfoContainer className={className}>
			<>
				<OfertaCardImageContainer className="oferta-card-image-container">
					<OfertaCardImage className="car-image-mobile" src={img34} alt={`${carline.title}`} />
				</OfertaCardImageContainer>

				{/* Título + info */}
				<Container
					data-testid="carline-info-container"
					wrap={'always'}
					verticalAlign={'center'}
					horizontalAlign={'space-between'}
					stretchContent
				>
					<TwoColumnsDiv>
						<OfertaCardTitleMobile carline={carline} currentOferta={currentOferta} />

						<CardControllers>
							<OpenLayerCTAContainer>
								<OpenLayerCTA buttonSize="large" />
							</OpenLayerCTAContainer>
						</CardControllers>
					</TwoColumnsDiv>
					<Container
						wrap={'never'}
						horizontalAlign={'space-between'}
						shrinkContent={{
							[Breakpoints.default]: true,
							[Breakpoints.b960]: false,
						}}
						stretchContent={{
							[Breakpoints.default]: false,
							[Breakpoints.b960]: true,
						}}
					>
						<Container wrap={'always'} stretchContent>
							<OfertaPrice oferta={currentOferta} />
						</Container>
					</Container>
				</Container>
			</>

			{/* Alinear el cta abajo */}
			<Container
				data-testid="pide-mas-info-mobile"
				padding={{
					top: ContainerPadding.static250,
				}}
				gutter={
					(
						serviceConfigProvider.configs['es-vwdata']?.customConfig as {
							brand?: string;
						}
					)?.brand == 'N'
						? ContainerGutter.dynamic0050
						: ContainerGutter.static0
				}
				verticalAlign="center"
				stretchContent
			>
				<RedirectCTAs
					copy={visibleOfertaMobile.calculatedFinance.rawResponse ? 'Pide presupuesto' : 'Pide esta oferta'}
					emphasis="primary"
					oferta={visibleOfertaMobile}
					formTrigger={'es-oneform-v2'}
					isMobile={true}
				/>
				{(
					serviceConfigProvider.configs['es-vwdata']?.customConfig as {
						brand?: string;
					}
				)?.brand == 'N' &&
					isCallMeNowOpen && (
						<RedirectCTAs
							copy={'¿Te llamamos?'}
							emphasis="secondary"
							oferta={selectedOferta ?? currentOferta}
							formTrigger="es-oneform-callme-embedded"
							isMobile={true}
						/>
					)}
			</Container>
		</OfertaInfoContainer>
	);
};
